export default __webpack_public_path__ + "static/media/analist.274625e8.svg";